import React, { useState, useEffect } from "react";
// import UploadImage from "./UploadImage";
import API from "../../Services/axios";
import * as XLSX from 'xlsx';

const Events_User = () => {
  const [users, setUsers] = useState([]);
  const [count, setCount] = useState(0);
  const [selectedYear, setSelectedYear] = useState(
    new Date().getFullYear().toString()
  );
  const [loading, setLoading] = useState(false);
  // const [email, setEmail] = useState();
  // const [singleuser, setSingleUser] = useState();

  // Helper function to format date
  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const day = date
      .getDate()
      .toString()
      .padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Helper function to process data for Excel export
  const processDataForExcel = (data) => {
    const fieldsToExclude = [
      "image",
      "cap",
      "timestamp",
      "sk",
      "pk",
      "avatar",
      "events",
      "room number (na if not applicable)",
      "hostel (na if not applicable)",
    ];

    return data.map((user) => {
      const processedUser = {};

      Object.keys(user).forEach((key) => {
        // Skip excluded fields
        if (fieldsToExclude.includes(key)) {
          return;
        }

        // Format updatedAt field
        if (key === "updatedAt") {
          processedUser[key] = formatDate(user[key]);
        } else if (typeof user[key] === "object" && user[key] !== null) {
          // Convert objects to JSON string for Excel
          processedUser[key] = JSON.stringify(user[key]);
        } else {
          processedUser[key] = user[key];
        }
      });

      return processedUser;
    });
  };

  // Helper function to filter users by year
  const filterUsersByYear = (userData, year) => {
    return userData.filter((user) => {
      if (user.updatedAt) {
        const userYear = new Date(user.updatedAt).getFullYear();
        return userYear.toString() === year;
      }
      return false;
    });
  };

  // Generate year options for the dropdown (past 3 years)
  const getYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 0; i < 3; i++) {
      years.push((currentYear - i).toString());
    }
    return years;
  };

  // Helper function to download data as Excel
  const downloadExcel = () => {
    if (users.length === 0) {
      alert("No data to download. Please fetch users first.");
      return;
    }

    try {
      const processedData = processDataForExcel(users);

      // Create workbook and worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(processedData);

      // Set column widths for better readability
      const headers = Object.keys(processedData[0] || {});
      const columnWidths = headers.map(() => ({ wch: 20 })); // Default width for all columns
      worksheet['!cols'] = columnWidths;

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, `CAP Users ${selectedYear}`);

      // Generate filename with selected year
      const filename = `CAP_Users_${selectedYear}.xlsx`;

      // Write and download the file
      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
      alert("Error downloading Excel file. Please try again.");
    }
  };

  const getUsers = async () => {
    setLoading(true);
    try {
      const data = (await API.get(`/users/cap`)).data;
      console.log(data);
      const filteredData = filterUsersByYear(data, selectedYear);
      setUsers(filteredData);
      setCount(filteredData.length);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  // const getSingleUser = async (e) => {
  //     if (email) {
  //         e.preventDefault();
  //         const data = (
  //             await API.get(`/users/${email}`)
  //         ).data;
  //         setSingleUser(data);
  //     } else {
  //         alert("Please Fill all required fields");
  //     }
  // };

  return (
    <>
      <div className="col-lg-7">
        <div
          className="p-1 mx-auto mt-1 mb-1 col-lg-5 card"
          style={{ maxHeight: "400px", overflowY: "scroll" }}
        >
          <div className="mx-auto fw-bold">
            <div className="mb-2">
              <label htmlFor="yearSelect" className="form-label">
                Select Year:
              </label>
              <select
                id="yearSelect"
                className="mb-2 form-select"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                {getYearOptions().map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
            Get Users ( Total users {count} for {selectedYear} )
            <button
              className="btn btn-outline-primary"
              type="button"
              id="button-addon2"
              onClick={getUsers}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Loading...
                </>
              ) : (
                "View Users"
              )}
            </button>
            <button
              className="btn btn-outline-success ms-2"
              type="button"
              onClick={downloadExcel}
              disabled={users.length === 0}
            >
              Download Excel
            </button>
          </div>
        </div>
        <div className="accordion accordion-flush" id="accordionFlushExample">
          {users &&
            users
              .sort(function(a, b) {
                return a.timestamp - b.timestamp;
              })
              .reverse()
              .map((gallery, idx) => (
                <div key={idx} className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingOne">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#flush-collapse${idx}`}
                      aria-expanded="false"
                      aria-controls={`flush-collapse${idx}`}
                    >
                      {gallery.name}
                    </button>
                  </h2>
                  <div
                    id={`flush-collapse${idx}`}
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingOne"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      {Object.keys(gallery).map((key, index) => {
                        // Filter out unwanted fields
                        if (
                          key === "image" ||
                          key === "cap" ||
                          key === "timestamp" ||
                          key === "sk" ||
                          key === "pk" ||
                          key === "avatar" ||
                          key === "events" ||
                          key === "room number (na if not applicable)" ||
                          key === "hostel (na if not applicable)"
                        ) {
                          return null;
                        }

                        // Handle updatedAt field formatting
                        if (key === "updatedAt") {
                          return (
                            <div className="d-flex" key={index}>
                              <span className="mx-2">{key} :</span>
                              <span className="mx-2">
                                {formatDate(gallery[key])}
                              </span>
                            </div>
                          );
                        }

                        return (
                          <div className="d-flex" key={index}>
                            <span className="mx-2">{key} :</span>
                            {typeof gallery[key] === "object" &&
                            gallery[key] !== null ? (
                              <ul className="mx-2">
                                {Object.entries(gallery[key]).map(
                                  ([subKey, subValue], subIndex) => (
                                    <li key={subIndex}>
                                      {subKey}:{" "}
                                      {subValue &&
                                      typeof subValue === "object" ? (
                                        <ul>
                                          {Object.entries(subValue).map(
                                            (
                                              [innerKey, innerValue],
                                              innerIndex
                                            ) => (
                                              <li key={innerIndex}>
                                                {innerKey}:{" "}
                                                {innerValue.toString()}
                                              </li>
                                            )
                                          )}
                                        </ul>
                                      ) : (
                                        subValue && subValue.toString()
                                      )}
                                    </li>
                                  )
                                )}
                              </ul>
                            ) : (
                              <span className="mx-2">
                                {gallery[key] && gallery[key].toString()}
                              </span>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              ))}
        </div>
      </div>
    </>
  );
};

export default Events_User;
